module.exports = __webpack_public_path__ + "static/img/Pay_QrCode.86450313.jpg";